import request from './request';
import {
  DOWNLOAD_EVENT_API,
  EVENT_CATEGORIES_API,
  EVENTS_LOCATIONS_API,
  EVENTS_API,
  HOMEPAGE_EVENTS_API,
  MODIFY_EVENT_API,
} from '@/urls';
import {API_METHODS} from '@/const';
import {ejectAbortSignal} from '@/utils/helpers';

export default {
  get_events_list({
    tracking = [],
    ...params
  } = {}, token) {
    return request({
      url: EVENTS_API,
      method: API_METHODS.GET,
      params,
      token,
      tracking: [...tracking],
    });
  },
  get_event(props) {
    const {token, params} = ejectAbortSignal(props);
    const {id} = params;
    return request({
      url: `${EVENTS_API}/${id}`,
      method: API_METHODS.GET,
      token,
    });
  },
  download_event({id}) {
    return request({
      url: `${DOWNLOAD_EVENT_API}/${id}`,
      method: API_METHODS.GET,
    });
  },
  get_event_categories(params = {}) {
    return request({
      url: EVENT_CATEGORIES_API,
      method: API_METHODS.GET,
      params,
    });
  },
  get_event_locations() {
    return request({
      url: EVENTS_LOCATIONS_API,
      method: API_METHODS.GET,
    });
  },
  get_home_page_events(params = {}) {
    return request({
      url: HOMEPAGE_EVENTS_API,
      method: API_METHODS.GET,
      params,
    });
  },
  get_modified_timestamp(id) {
    return request({
      url: `${MODIFY_EVENT_API}/${id}`,
      method: API_METHODS.GET,
      config: {
        apiKeyNeed: false,
        retryCount: 0,
        globalError: false,
        crashCodes: [],
        allowedCodes: [],
        crashByDefaultErrors: false,
      },
    });
  },
};
